{
  "Net EXP includes only confirmed segments; gaps are excluded. The rate covers only the uninterrupted segment after recovery.": "淨經驗僅累計已確認片段，缺口未計入；目前時速僅統計恢復後連續區間。",
  "Net EXP includes only confirmed segments; gaps are excluded. The average uses confirmed segment duration.": "淨經驗僅累計已確認片段，缺口未計入；平均效率按已確認片段時長計算。",
  "First session gap": "首次缺口",
  "Ready": "可升級",
  "{p0}m": "{p0}分鐘",
  "{p0}h {p1}m": "{p0}小時{p1}分",
  "{p0}d {p1}h": "{p0}天{p1}小時",
  "Map unconfirmed": "暫無法確認地圖",
  "Map pending confirmation": "地圖待確認",
  "Waiting for map recognition": "等待地圖識別",
  "Recognizing map": "地圖識別中",
  "Finishing": "正在結束",
  "Confirming": "確認中",
  "Net EXP": "淨經驗",
  "Gained": "本次",
  "4h 57m": "4小時57分",
  "8h 51m": "8小時51分",
  "Victoria Island / Forest of Wisdom": "維多利亞島 / 智慧之森",
  "Maple Log": "楓記",
  "Widget": "小工具",
  "Loading widget…": "正在載入小工具…",
  "Your panel will appear when ready": "準備完成後，資料面板將自動顯示",
  "": "",
  "Waiting for readings": "等待讀數",
  "Gathering samples": "積累樣本",
  "No rate available": "暫無統計",
  "Since recovery": "恢復後效率",
  "Confirming an EXP change.": "正在核對經驗變化。",
  "Waiting for a fresh level reading.": "等待等級讀數。",
  "Cross-level EXP evidence is missing.": "跨級經驗缺失。",
  "Waiting for a readable game frame.": "畫面暫不可讀，等待新的清晰讀數。",
  "The EXP change could not be confirmed in time.": "經驗變化未能在確認時間內完成核對。",
  "Capture continuity was interrupted during confirmation.": "確認期間採集連續性中斷。",
  "EXP / hour": "經驗 / 小時",
  "Waiting for complete EXP evidence.": "等待完整的經驗確認資訊。",
  "Some EXP readings could not be confirmed, so session net EXP is unavailable. The rate covers only the uninterrupted segment after recovery.": "有一段經驗未能確認，因此暫不顯示本場淨經驗。恢復後效率只統計恢復後的連續區間。",
  "Recovery baseline": "恢復起點",
  "Last confirmed": "上次確認",
  "EXP/h": "經驗/小時",
  "Showing the last confirmed values while checking.": "校驗期間顯示上次確認值，尚未計入待確認經驗。",
  "The last reading is too old to show as a current rate.": "上次讀數已過期，暫不作為當前效率顯示。",
  "Last 60s: {p0} EXP/h\nSession average: {p1} EXP/h\nDifference: {p2} EXP/h\nLast sample: {p3}\nArrows appear at 4% and hide 1.5s after returning to 2%, with recognition-delay protection. Window edges and cross-level gains may be estimated.": "近 60 秒：{p0} 經驗/小時\n全程平均：{p1} 經驗/小時\n差值：{p2} 經驗/小時\n樣本時間：{p3}\n偏差達到 4% 時顯示，回落至 2% 後延遲 1.5 秒隱藏，並排除識別延遲造成的偏差。視窗邊界和跨級經驗可能採用估算。",
  "Elapsed": "記錄時長",
  "EXP / h": "EXP / 小時",
  "Mesos / h": "楓幣 / 小時",
  "Map": "地圖",
  "Recognizing": "識別中",
  "Start": "開始記錄",
  "Pause": "暫停",
  "Resume": "繼續",
  "End": "結束",
  "Confirming EXP": "正在確認經驗",
  "HP": "HP",
  "MP": "MP",
  "Lv.": "等級",
  "Level up": "距升級",
  "Full level": "本級共需",
  "Change": "變化",
  "Net": "淨",
  "Live metrics": "實時資料",
  "Idle": "空閒",
  "Recording": "記錄中",
  "Paused": "已暫停",
  "Ended": "已結束",
  "Interrupted": "已中斷",
  "{p0}h": "{p0}小時",
  "EXP reading details": "經驗讀數說明",
  "Close": "關閉",
  "Loading preview…": "預覽載入中…",
  "Widget layout preview": "小工具佈局預覽",
  "Start balance": "開始持有",
  "Display unavailable. Reopen the widget.": "顯示異常，請重新開啟小工具。",
  "Reading details when opened": "開啟時的讀數說明",
  "Waiting to start": "等待開始記錄",
  "Waiting for valid data": "等待有效資料",
  "No chart data": "暫無曲線資料",
  "Waiting for a sample point": "等待取樣點",
  "{seconds}/{window}s": "{seconds}/{window} 秒",
  "Waiting for character": "等待角色識別"
}
